import React, { useState, useEffect } from 'react'

import DateSelection from './DatePicker/DateSelection'
import dayjs from 'dayjs'

const StayForm = ({
  widgetType,
  onChangePromoCode,
  onCalendarOpen,
  hidePromoField,
  values,
  setValues,
  passengerModalIsOpen,
  setPassengerModalIsOpen,
  passengerCount,
  submit,
  hasValidCart,
  initialEndDate,
}) => {
  const [promoCodeOpen, setPromoCodeOpen] = useState(!!values.promoCode)
  const [isDateAdjusted, setIsDateAdjusted] = useState(false)

  useEffect(() => {
    if (values.startDate === values.endDate && !isDateAdjusted) {
      setIsDateAdjusted(true)
      setValues({
        ...values,
        endDate: dayjs(initialEndDate).format('YYYY-MM-DD'),
      })
    }
  }, [isDateAdjusted, initialEndDate, values, setValues])

  return (
    <form
      onSubmit={event => {
        event.preventDefault()
        submit()
      }}
    >
      <div className="row-group">
        <div className="input-label date-inputs">
          <DateSelection
            startDate={values.startDate}
            startDateLabel="Check-in"
            endDate={values.endDate}
            endDateLabel="Check-out"
            handleSelectDate={(key, date) => {
              const currentValues = { ...values }
              if (key === 'startDate') {
                currentValues.startDate = date
                currentValues.endDate = ''
              } else if (key === 'endDate') {
                currentValues.endDate = date
              }
              setValues({
                ...currentValues,
              })
            }}
            isOneWay={false}
            widgetType={widgetType}
            onCalendarOpen={onCalendarOpen}
          />
        </div>
        <div className="input-label passengers">
          <label>
            <p>Guests</p>
          </label>
          <button
            type="button"
            onClick={() => setPassengerModalIsOpen(prev => !prev)}
            className={`drop-down-arrow ${passengerModalIsOpen ? 'open' : ''}`}
          >
            <>
              {passengerCount} Guest
              {passengerCount > 1 ? 's' : ''} |{' '}
              {values.hotelGuests?.length || 1} Unit
              {values.hotelGuests?.length > 1 ? 's' : ''}
            </>
          </button>
        </div>

        {hidePromoField ? null : (
          <div className="promo-code">
            {promoCodeOpen || !!values.promoCode ? (
              <div className="input-label">
                <label>
                  <p>Promo Code</p>
                  <input
                    className=""
                    value={values.promoCode || ''}
                    onChange={e => onChangePromoCode(e.target.value)}
                    placeholder="Enter a Promo Code"
                    onBlur={e => setPromoCodeOpen(!!e.target.value)}
                    autoFocus
                  />
                </label>
              </div>
            ) : (
              <button type="button" onClick={() => setPromoCodeOpen(true)}>
                Add promo code +
              </button>
            )}
          </div>
        )}

        <button type="submit" className="btn-primary">
          {hasValidCart ? 'New Search' : 'Search'}
        </button>
      </div>
    </form>
  )
}

export default StayForm
